import type { FC } from 'react';

import { Typography } from 'enable-ui';

import ClassDefaultIMG from 'assets/icons/class-default.png';

import { COLOR, COLOR_CONFIG } from 'constants/color';

export const ClassCompTable: FC<{ name: string; code: string; thumbnail: string }> = ({
  name,
  code,
  thumbnail,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <div>
        <img
          src={thumbnail || ClassDefaultIMG}
          alt="class"
          style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'cover' }}
        />
      </div>
      <div>
        <Typography
          style={{
            color: COLOR.surfaceNeutralBold['neutral-11'],
          }}
          weight={500}
        >
          {name}
        </Typography>
        <Typography
          style={{ fontSize: 16, lineHeight: '22px', color: COLOR_CONFIG['neutral-text'] }}
        >
          {code}
        </Typography>
      </div>
    </div>
  );
};
